const MenuList = [
  {
    name: "회사소개",
    url: "/subPage/intro/1",
    id: "intro",
    subMenu: [
      "인사말",
      "사업영역",
      "오시는길",
    ]
  },
  {
    name: "브랜드",
    url : "/subPage/brand/1",
    id: "brand",
    subMenu: []
  },
  {
    name: "제품안내",
    url : "/subPage/product/agdia/1",
    id: "product",
    subMenu: []
  },
  {
    name: "이벤트",
    url : "/subPage/event/event/1",
    id: "event",
    subMenu: []
  },
  {
    name: "고객센터",
    url : "/subPage/contact/1",
    id: "contact",
    subMenu: []
  },
]

export { MenuList }

